module.exports = __webpack_public_path__ + "5b13b6a1bfd825edc8668bac916d16cd.jpg";